import React from 'react';
export const CFIconLink = {
    alias: 'link',
    defaultTitle: 'Link',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M9 16H7.21c-2.106 0-4.006-1.535-4.193-3.634A4.003 4.003 0 0 1 7 8h2a1 1 0 1 0 0-2H7.209c-3.05 0-5.77 2.187-6.158 5.211A6.007 6.007 0 0 0 7 18h2a1 1 0 1 0 0-2Zm-1-4a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H9a1 1 0 0 0-1 1Zm8.759-6c3.067 0 5.819 2.197 6.194 5.242A6.007 6.007 0 0 1 17 18h-2a1 1 0 1 1 0-2h2a4.003 4.003 0 0 0 3.983-4.366C20.796 9.535 18.896 8 16.789 8h-1.79a1 1 0 0 1-1-1c0-.553.444-1 1.25-1h1.51Z' }))),
};
